<template lang="pug">
  .kpi-view
    el-table.kpi-table(
      :data="data"
      style="width: 400px"
    )
      el-table-column(
        prop="kpi_name"
        :label="$t('KPI名称')"
        align="left"
        width="135"
        show-overflow-tooltip
      )
        template(slot-scope="scope")
          span {{ $t(scope.row.kpi_name) }}
      el-table-column(
        :label="$t('量化指标')"
        align="left"
        show-overflow-tooltip
      )
        template(slot-scope="scope")
          span {{ numberWithCommas(scope.row.target, 0, false) }} {{ $t(scope.row.unit)  }}
      el-table-column(
        :label="$t('占比')"
        align="left"
        show-overflow-tooltip
      )
        template(slot-scope="scope")
          span {{ scope.row.kpi_percent }}%
</template>

<script>
import { numberWithCommas } from '@/umcc/util'

export default {
  props: {
    data: Array,
    default () {
      return []
    }
  },
  methods: {
    numberWithCommas: numberWithCommas
  }
}
</script>

<style lang="stylus">
</style>
